import
  {
    GET_ADMINS,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,

    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAIL,

    UPDATE_ADMIN_SUCCESS,
    UPDATE_ADMIN_FAIL,
  } from "./actionType";

const INIT_STATE = {
  admins: [],
  error: {},
};

const Admin = ( state = INIT_STATE, action ) =>
{
  switch ( action.type )
  {
    case API_RESPONSE_SUCCESS:
      switch ( action.payload.actionType )
      {
        case GET_ADMINS:
          return {
            ...state,
            admins: action.payload.data,
            isAdminCreated: false,
            isAdminSuccess: true
          };

        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch ( action.payload.actionType )
      {
        case GET_ADMINS:
          return {
            ...state,
            error: action.payload.error,
            isAdminCreated: false,
            isAdminSuccess: false
          };

        default:
          return { ...state };
      }

    case ADD_ADMIN_SUCCESS:
      return {
        ...state,
        isAdminCreated: true,
        admins: [ ...state.admins, action.payload.data ],
        isAdminAdd: true,
        isAdminAddFail: false
      };

    case ADD_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
        isAdminAdd: false,
        isAdminAddFail: true
      };

    case UPDATE_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.map( admin =>
          admin.id === action.payload.id
            ? { ...admin, ...action.payload }
            : admin
        ),
        isAdminUpdate: true,
        isAdminUpdateFail: false
      };

    case UPDATE_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
        isAdminUpdate: false,
        isAdminUpdateFail: true
      };

    default:
      return { ...state };
  }
};

export default Admin;
